<script lang="ts">
	import { AdvancedCard } from '@Shelly/shelly-design-system';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	import VirtualButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualButton.svelte';
	//Components
	import TemplateLabel from './TemplateLabel.svelte';
	import TemplateSlider from './TemplateSlider.svelte';
	import TemplateProgressbar from './TemplateProgressbar.svelte';
	import TemplateField from './TemplateField.svelte';
	import TemplateDropdown from './TemplateDropdown.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];
</script>

{#each statuses as status}
	{#if !status.hideLabel || status.hasAction}
		{@const view = status?.config?.meta?.ui?.view}
		{#if view === 'slider'}
			<TemplateSlider {device} {status} />
		{:else if view === 'progressbar'}
			<TemplateProgressbar {status} />
		{:else if view === 'field'}
			<TemplateField {device} {status} type={status.vcType} />
		{:else if view === 'dropdown' || view === 'select'}
			<TemplateDropdown {device} {status} />
		{:else if status.hasAction}
			<AdvancedCard title={translateTemplateTitle(status.name)} size="m" class="mb-s">
				<svelte:fragment slot="right">
					{#if status.vcType == 'boolean'}
						<VirtualBooleanButton
							{device}
							componentID={status.id}
							value={status.event}
							icon="fa fa-power-off"
						/>
					{:else}
						<VirtualButton
							{device}
							componentID={status.id}
							value={status.event}
							icon={status.icon || 'fa fa-power-off'}
						/>
					{/if}
				</svelte:fragment>
			</AdvancedCard>
		{:else}
			<TemplateLabel {status} />
		{/if}
	{/if}
{/each}
